import { BaseField } from './BaseField';

const imgFloorIcon = "/assets/floor-icon.svg";

export class FloorNumericField extends BaseField {
  constructor() {
    super({
      key: 'floor_numeric',
      icon: imgFloorIcon,
      defaultLabel: 'Piętro'
    });
  }

  renderForList(property) {
    return {
      label: this.defaultLabel,
      value: property.location.floor !== null && property.location.floor !== undefined
        ? String(property.location.floor)
        : ''
    };
  }

  renderForCard(property) {
    return this.renderForList(property);
  }
}